import { Box, Button, Divider, ListItemIcon, Typography } from '@mui/material';
import { Attachment as AttachmentIcon } from '@mui/icons-material';

import { FileDto } from '@bandido/shared/dtos';

import { downloadCaseAttachment } from '../../queries';
import AudioWave from '../../../common/components/AudioWave';

interface AttachmentsListProps {
  files?: FileDto[];
}

const AttachmentsList = ({ files }: AttachmentsListProps) => {
  if (!files?.length) return;

  const handleDownloadAttachment = (fileId: number) => () => downloadCaseAttachment(fileId);

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
      }}
    >
      <Divider
        sx={{
          mt: 1,
          mb: 2,
        }}
      />
      <Box sx={{ display: 'flex', gap: 1, p: 0, flexWrap: 'wrap', maxWidth: 700 }}>
        {files.map((file, index) => {
          const isAudio = file.mimetype.startsWith('audio/');
          return (
            <Box
              sx={{
                gap: 1,
                display: 'flex',
                borderRadius: 1,
                p: 0,
              }}
              key={index}
            >
              {isAudio ? (
                <AudioWave fileId={file.id} />
              ) : (
                <Button
                  size="small"

                  sx={{
                    maxWidth: 250,
                    backgroundColor: (theme) => theme.palette.background.paper,
                    border: (theme) => `1px solid ${theme.palette.divider}`,
                    textTransform: 'lowercase',
                    gap: 1,
                  }}
                  variant="text"
                  onClick={handleDownloadAttachment(file.id)}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 'fit-content',
                    }}
                  >
                    <AttachmentIcon />
                  </ListItemIcon>
                  <Typography sx={{
                    flexGrow: 1,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                  }} color="text.primary" variant="subtitle2">
                    {file.filename}
                  </Typography>
                </Button>
              )}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default AttachmentsList;
